// src/intake/submitIntake.ts
// ─────────────────────────────────────────────────────────────────────────────
// Brief 23 — Pipedream submission handler for intake form
// ─────────────────────────────────────────────────────────────────────────────

const PIPEDREAM_URL = 'https://eo5b3won204rirh.m.pipedream.net';

export async function submitIntake(answers: Record<string, string>): Promise<void> {
  const response = await fetch(PIPEDREAM_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      formId: 'ffm-custom-intake',
      submittedAt: new Date().toISOString(),
      fields: answers,
    }),
  });

  if (!response.ok) {
    throw new Error(`Submission failed: ${response.status}`);
  }
}
